"use strict";

import { Collection } from "Collection";
import { SubsystemsModel } from 'Models/SubsystemsModel';
import { Objects } from "Constants/objects";
export var SubsystemsCollection = Collection.extend({
  model: SubsystemsModel,
  object: Objects.SysSubsystems
});